export default "__VITE_ASSET__Catd6BFn__"